import { isGeneralAgentLifecycleEligible } from '@apps/web/lib/chat_access';
import { type CustomerLifecycleStage } from '@libraries/typescript/api_client';

// Who gets Learn Phoebe. The page is readable content, so it is always
// available; the parts that depend on the chat existing are not.
type LearnPhoebeOrganization =
    | {
          readonly customer_lifecycle_stage?: CustomerLifecycleStage | null;
      }
    | null
    | undefined;

// The sidebar widget costs a request on every page load, and its whole purpose
// is to get the scheduler into the chat — so it only appears for orgs that can
// actually use the agent.
export function canShowGetStartedChecklist(
    organization: LearnPhoebeOrganization,
): boolean {
    return isGeneralAgentLifecycleEligible(
        organization?.customer_lifecycle_stage,
    );
}

// "Try in chat" needs a chat to land in. Without one, the seeded draft would
// sit in UI context and resurface unprompted in the next composer that mounts.
export function canTryInChat(organization: LearnPhoebeOrganization): boolean {
    return isGeneralAgentLifecycleEligible(
        organization?.customer_lifecycle_stage,
    );
}
